import { render, staticRenderFns } from "./ContentTypeNewFieldsetBtn.vue?vue&type=template&id=7cc81f90"
import script from "./ContentTypeNewFieldsetBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeNewFieldsetBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports